module.exports = __webpack_public_path__ + "static/media/IMG_0611 - Version 2.08e6c65b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/IMG_0611 - Version 2.JPG
// module id = 519
// module chunks = 0